define(['angular', 'moment'], function(angular, moment) {


    /**
     * @class EulerService
     */
    function EulerService($root, $q, $log, eulerProvider) {
        let self = this;

        self.getRisk = function(siren) {
            let d = $q.defer();
            eulerProvider.getRisk(siren).then(resdata => {
                d.resolve(resdata);
            }, d.reject.bind(d));
            return d.promise;
        };

        return self;
    }

    EulerService.$inject = ['$rootScope', '$q', '$log', 'euler'];

    angular.module('app.bdc.common.eulerService', []).factory('eulerService', EulerService);
});
